const types = {
  GET_CLINICIANS: '@@IO_ABIECLINICIANS/GET_CLINICIANS',
  GET_CLINICIANS_COUNT: '@@IO_ABIECLINICIANS/GET_CLINICIANS_COUNT',
  LOAD_CLINICIANS: '@@IO_ABIECLINICIANS/LOAD_CLINICIANS',
  SET_LOADING_CLINICIANS: '@@IO_MATCHES_CLINICIANS/SET_LOADING_CLINICIANS',
  SET_ERROR: '@@IO_MATCHES_CLINICIANS/SET_ERROR',
  SET_SEARCH_TERM: '@@IO_MATCHES_CLINICIANS/SET_SEARCH_TERM',
  RESET_CLINICIANS: '@@IO_MATCHES_CLINICIANS/RESET_CLINICIANS',
  GET_OTHER_CLINICIANS: '@@IO_MATCHES_CLINICIANS/GET_OTHER_CLINICIANS',
  GET_FILTERED_CLINICIANS: '@@IO_MATCHES_CLINICIANS/GET_FILTERED_CLINICIANS',
  GET_MORE_FILTERED_CLINICIANS: '@@IO_MATCHES_CLINICIANS/GET_MORE_FILTERED_CLINICIANS',
  GET_DISPLAYED_CLINICIANS: '@@IO_MATCHES_CLINICIANS/GET_DISPLAYED_CLINICIANS',
};

export default types;
